import { AppTemplate } from "src/models/appTemplate";
import { createEntityModel } from "src/store/models/entity/_shared";

export const AppTemplateEntityModel = createEntityModel<AppTemplate>();
